import { pushObjectDataLayer } from './gtm.events';

interface IAppInit {
  appInstanceId: string;
}

export const triggerInitializeAppEvent = (customer: IAppInit) => {
  globalThis.dataLayer = globalThis.dataLayer || [];

  const data = {
    event: 'app_init',
    tipoevento: 'web iniciada',
    app_instance_id: customer.appInstanceId,
  };
  pushObjectDataLayer(data, triggerInitializeAppEvent.name);
};
